import { injectGlobal } from '@bd/bdui-styles/emotion';

const typography = {
  SansSerif: '\'eurostile\', sans-serif',
  Serif: '\'eurostile\', sans-serif',
  Display: '\'eurostile\', sans-serif',
};

injectGlobal(`
  ${
    typography.SansSerif &&
    `
      .text-sans-serif {
        font-family: ${typography.SansSerif}
      }
    `
  }

  ${
    typography.Serif &&
    `
      .text-serif {
        font-family: ${typography.Serif}
      }
    `
  }

  ${
    typography.Display &&
    `
      .text-display {
        font-family: ${typography.Display}
      }
    `
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js